import axios from './http'

export function getOcrIndicator(token) {
  return axios({
    url: '/api/data-center/getOcrIndicator',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}
